export const omit = (keysToOmit: string[], obj: Record<string, any>) =>
  Object.fromEntries(Object.entries(obj).filter(([key]) => !keysToOmit.includes(key)));
